// extracted by mini-css-extract-plugin
export default {"description":"style_description__fZvhf","fade-in":"style_fade-in__Tvew-","top":"style_top__9FCtB","image":"style_image__xzJSo"};